import { useSelect } from "@wordpress/data";
import { useState, useEffect } from "@wordpress/element";

export default function tabbed_doc_list({ attributes, docSections, articlesNumber, multiDocs }) {
    const { col, readMoreText, docs_layout, sectionsNumber, orderBy, child_docs_order, parent_docs_order } = attributes;

    // State for active tab
    const [activeTab, setActiveTab] = useState(null);

    // Fetch all documents (both parents and children)
    const allDocs = useSelect(
        (select) =>
            select("core").getEntityRecords("postType", "docs", {
                per_page: -1, // Fetch all documents
                status: ["publish", "private"],
                orderby: orderBy,
                order: child_docs_order,
            }),
        [orderBy, child_docs_order]
    );

    useEffect(() => {
        if (docSections && docSections.length > 0) {
            // Set the first section as the default active tab
            setActiveTab(docSections[0].id);
        } else if (multiDocs && multiDocs.length > 0) {
            // Set the first multiDoc as the default active tab if docSections is empty
            setActiveTab(multiDocs[0].id);
        }
    }, [docSections, multiDocs]);

    if (!allDocs) return <p>Loading...</p>;
    if (allDocs.length === 0) return <p>No documents found.</p>;

    // Separate parent and child documents
    const mainDocs = allDocs.filter((doc) => doc.parent === 0);  // Parent docs are those with parent === 0
    const getChildDocs = (parentId) =>
        allDocs.filter((doc) => doc.parent === parentId);  // Children are filtered by parentId
    
    const layoutType = docs_layout === "grid" ? `ezd-grid ezd-column-${col} topic_list_inner` : `ezd-masonry-wrap ezd-masonry-col-${col} topic_list_inner`;

    return (
        <>
        <section class="doc_tag_area" id="Arrow_slides-bada9fe">
            <div class="tabs_sliders">
                <span class="scroller-btn left inactive"><i class="arrow_carrot-left"></i></span>
                
                <ul class="nav nav-tabs doc_tag ezd-tab-menu slide_nav_tabs ezd-list-unstyled">
                    
                        {(docSections || multiDocs) &&
                            [...(docSections || []), ...(multiDocs || [])].map((section) => {
                                const { id, title, slug } = section;

                                return (
                                    <li className="nav-item" key={id}>
                                        <a
                                            data-rel={slug}
                                            className={`nav-link ezd_tab_title ${
                                                activeTab === id ? "active" : ""
                                            }`}
                                            onClick={() => setActiveTab(id)}
                                        >
                                            {title.rendered}
                                        </a>
                                    </li>
                                );
                            })
                        }
                </ul>

                <span class="scroller-btn right inactive"><i class="arrow_carrot-right"></i></span>
            </div>
            <div class="ezd-tab-content">
                {(docSections || multiDocs) &&
                    [...(docSections || []), ...(multiDocs || [])].map((section) => {
                        // Get child docs for this section
                        const childDocs = getChildDocs(section.id).slice(0, sectionsNumber);

                        return (
                            <div className={`doc_tab_pane ezd-tab-box ${activeTab === section.id ? "active" : "" }`} id={section.slug} key={section.id}>
                                <div className={layoutType}>
                                    
                                {childDocs.length > 0 && (
                                        childDocs.map((childDoc) => (

                                        <div key={childDoc.id}>
                                            <div class="doc_tag_item">
                                                <div class="doc_tag_title">
                                                    <h4 class="ezd_item_title">{childDoc.title.rendered}</h4>
                                                    <div class="line"></div>
                                                </div>

    
                                                <ul class="ezd-list-unstyled tag_list">
                                                    {allDocs
                                                    .filter((doc) => doc.parent === childDoc.id).slice(0, articlesNumber) // Filter child docs
                                                    .map((nestedChild) => (
                                                        <li key={nestedChild.id}>
                                                            <a href="#" className="ezd_item_list_title">
                                                                {nestedChild.title.rendered}
                                                            </a>
                                                        </li>
                                                        
                                                    ))}
                                                </ul>
                                                <a href={childDoc.link} className="text_btn dark_btn ezd_btn">
                                                    {readMoreText || "View All"} <i className="arrow_right"></i>
                                                </a>
                                            </div>
                                       
                                        </div> 
                    )))}
                               
                                    </div> 
                                    </div>    
                             
                
                            );
})}
        
            </div>
        </section>
        </>
    );
}
